/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">订单详情</h3>
          <div class="headerButton">
              <span style="line-height: 28px;">订单号：<i>{{orderList.orderNumber||'--'}}</i></span>
              <div v-if="iscancle?false:true">
                    <el-button  v-if="orderList.status == 1?true:false" size="mini" @click="payOrderNow(orderList.amount,orderList.transportfee)">去支付</el-button>                   
                    <el-button v-if=" orderList.status == 1?true:false" size="mini" @click="cancleOrder(orderList.oid)">取消订单</el-button>
                    <div v-if="!orderList.pointsPay">
                        <!-- <el-button v-if="orderList.status==2&&!orderList.bxyCommodityList[0].isRefund?true:false" size="mini" @click="reBackMoney(orderList.bxyCommodityList)"> 退款</el-button> -->
                    </div>
                    <!-- <el-button v-if="orderList.status==5|| orderList.status==2?false:true" size="mini" @click="cancleOrder(orderList.oid)">取消订单</el-button> -->
              </div>
              <!-- <div v-if="iscancle?true:false">
                   <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(orderList.oid)">移出订单</el-button>
              </div> -->
          </div>
          <el-divider></el-divider>
          <div>
              <el-row class="order_goods" v-for='goodsItem in orderList.bxyCommodityList' :key="goodsItem.id">
                    <el-col :span="2"> 
                           <el-image @click="jumpGoodsDetail(goodsItem)" :src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`" class="bg"
                            style="width: 62px; height: 62px"
                            >
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                    </el-col> 
                    <el-col :span="16" class="order_Info_item">
                        <p><span style="color:#ff6700" v-if="goodsItem.type==2">虚拟商品</span></p>
                        <p @click="jumpGoodsDetail(goodsItem)">  {{goodsItem.name}}  <p style="color:#ff6700">{{goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</p>
                        <p>(<span v-if="orderList.pointsPay">{{orderList.pointsPay}}积分
                             +</span> {{goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].price:goodsItem.realprice}} 元) * {{goodsItem.number || 1}}</p>
                        <!-- <p>{{goodsItem.name}} {{goodsItem.specificationlist[0].name}}</p> -->
                    </el-col>

                    <!-- 买家已付款了 退款按钮 -->
                    <!-- <el-col :span="4" class="order_Info_item" v-if="!orderList.pointsPay">
                        <el-button class="reBackMoney" v-if="orderList.status==2&&!goodsItem.isRefund?true:false" size="mini" @click="reBackMoney(goodsItem)">退款</el-button>
                       </el-col>   -->

                     <!-- 买家已付款了 退款按钮 -->
                    <el-col :span="4" class="order_Info_item" v-if="!orderList.pointsPay&&goodsItem.isRefund==0&&goodsItem.isRefund!=-1">
                        <!-- 没有物流 先按交易成功算 -->
                        <el-button class="reBackMoney" v-if="orderList.status<6&&orderList.status>=2 &&orderList.bxunyouMerchant.isdel!=1&&orderList.bxunyouMerchant.power!=2 " size="mini" @click="reBackMoney(goodsItem)">退款</el-button>
                    </el-col> 
                    <el-col :span="4" class="order_Info_item" v-if="!orderList.pointsPay&&(goodsItem.isRefund==18||goodsItem.isRefund==17)&&goodsItem.isRefund!=-1">
                        <!-- 没有物流 先按交易成功算 -->
                        <el-button class="reBackMoney" v-if="orderList.status<6&&orderList.status>=2&&orderList.bxunyouMerchant.isdel!=1&&orderList.bxunyouMerchant.power!=2" size="mini" @click="reApplyMoney(goodsItem)">重新退款</el-button>
                    </el-col> 
                    <el-col :span="4" class="order_Info_item" v-if="goodsItem.isRefund!=0&&goodsItem.isRefund<16&&goodsItem.isRefund!=-1">
                        <el-button class="reBackMoney" v-if="goodsItem.isRefund!=0&&goodsItem.isRefund<16 &&orderList.bxunyouMerchant.isdel!=1&&orderList.bxunyouMerchant.power!=2" size="mini" @click="$router.push(`/refundDetail?refund=1&returnOrder=${goodsItem.returnOrder}`)">退款中</el-button>
                    </el-col> 
                    <el-col :span="4" class="order_Info_item" v-if="goodsItem.isRefund!=-1&&goodsItem.isRefund==16">
                       <el-button class="reBackMoney" size="mini" @click="$router.push(`/refundDetail?refund=1&returnOrder=${goodsItem.returnOrder}`)">退款详情</el-button>
                    </el-col> 
                </el-row>

                <!-- 等待买家付款 -->
                <el-row class="order_goods">
                    <el-col :span="24" class="info_title">{{orderStatus(orderList.status)}}</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>下单时间： {{orderList.createTime}}</p>
                        <p>付款时间： {{orderList.payTime||'0000-00-00 00 ：00 ：00'}}</p>
                    </el-col>                             
                </el-row>

                <!-- 虚拟商品核销码 -->
                <el-row class="order_goods" v-if="orderList.status!=1&&orderList.status!=5&&orderList.sellCodeList">
                    <el-col v-if="orderList.sellCodeList.length>0">
                        <el-col :span="24" class="info_title">券码信息</el-col> 
                        <el-col  v-for="(codeItem,index) in orderList.sellCodeList" :key='index'>
                            <el-col :span="8"  class="info_content">
                                <p>核销码： <span :class="codeItem.sellStatus==1?'codeStyle':'codeUsedStyle'">{{codeItem.sellCode}}</span></p>
                            </el-col>   
                            <el-col :span="6"  class="info_content">
                                <p class="">{{codeItem.sellStatus==1?'未使用':'已使用'}}</p>
                            </el-col>  
                            <el-col :span="6"  class="info_content">
                                <p class="getUser" v-if="codeItem.sellStatus==1" @click="creatQrCode(codeItem.sellCode)">查看核销码</p>
                            </el-col>  
                        </el-col>   
                    </el-col>                       
                </el-row>

                <!-- 收货信息 -->
                <el-row class="order_goods" v-if="orderList.bXyShoppingAddress!=null">
                    <el-col :span="24" class="info_title">收货信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>姓名： {{orderList.bXyShoppingAddress.recipient}}</p>
                        <p>联系电话： {{orderList.bXyShoppingAddress.phoneNumber}}</p>
                        <p>收货地址： {{orderList.areaName}}  {{orderList.bXyShoppingAddress.address}}</p>
                        <p>订单备注:  {{orderList.desc}}</p>
                    </el-col>                             
                </el-row>

                <!-- 物流信息 后期开发-->
                <el-row class="order_goods" v-if='orderList.bxyCommodityList[0].type!=2&&(orderList.status==4 || orderList.status==3)'>
                    <el-col :span="24" class="info_title">物流信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>物流公司： {{logistics_name}}</p>
                        <p>运单号码： {{orderList.logisticsNumber || '78164982674324'}}</p>
                    </el-col>  
                    <el-col :span="24" v-if="deliver.length>0">
                        <el-collapse v-model="activeName" accordion class="getLogistics">
                            <el-collapse-item title="查看物流" name="1">
                                <el-steps direction="vertical" :active="1">
                                    <el-step icon="el-icon-position" v-for="(deliverItem,index) in  deliver" :key="index" :title="deliverItem.ftime" :description="deliverItem.context"></el-step>
                                </el-steps>
                            </el-collapse-item>
                            </el-collapse>
                    </el-col>                           
                </el-row>

                <!-- 支付方式及送货时间 后期开发-->
                <!-- <el-row class="order_goods">
                    <el-col :span="24" class="info_title">支付方式及送货时间</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>支付方式： {{'在线支付'}}</p>
                        <p>送货时间： {{'0000-00-00 00：22：22'}}</p>
                    </el-col>                             
                </el-row> -->

                <!-- 发票信息 -->
                <el-row class="order_goods" v-if="orderList.bXyInvoice!=null" >
                    <el-col :span="24" class="info_title">发票信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>发票类型： {{orderList.bXyInvoice.type==1?'电子发票': orderList.bXyInvoice.type==3?'专用发票':'非电子发票'}}</p>
                        <p>发票内容： {{`发票抬头 - ${orderList.bXyInvoice.invoiceTitle}`}}</p>
                    </el-col>   
                    <el-col :span="24" v-if="orderList.bXyInvoice.type==3"  class="info_content">
                        <p>公司税号： {{orderList.bXyInvoice.taxpayerNumber}}</p>
                        <p>注册地址： {{orderList.bXyInvoice.address}}</p>
                        <p>注册电话： {{orderList.bXyInvoice.tel}}</p>
                        <p>开户银行： {{orderList.bXyInvoice.bank}}</p>
                        <p>银行账号： {{orderList.bXyInvoice.bankAccount}}</p>
                        <p style="font-weight: bold;">收票人信息</p>
                        <p>姓名： {{orderList.bXyInvoice.invoiceName}}</p>
                        <p>手机： {{orderList.bXyInvoice.invoiceTel}}</p>
                        <p>地址： {{orderList.bXyInvoice.invoiceAddress}}</p>
                    </el-col>                          
                </el-row>

                 <!-- 商品总价 -->
                <el-row class="footer_total">
                    <el-col :span="20">
                        <p>会员折扣:</p>
                        <p>活动优惠:</p>
                        <p>红包抵扣:</p>
                        <p>商品总价:</p>
                        <p>运费:</p>
                        <p>总金额:</p>
                    </el-col>
                    <el-col :span="4"  class="footer_total_money">
                        <p>-{{orderList.discountOffer  || 0}} 元</p>
                        <p>-{{orderList.activityDiscount  || 0}} 元</p>
                        <p>-{{orderList.redPay || 0}} 元</p>
                        <p>{{orderList.amount || 0}} 元</p>
                        <p>{{orderList.transportfee||0}} 元</p>
                        <p class="finalTotal">{{totalMoney||0}} 元</p>
                    </el-col>                             
                </el-row>

          </div>

           <!-- 加入进货单弹框 -->
            <el-dialog
            class="addCartBox"
            :visible.sync="codeVisible"
            :destroy-on-close=true
            width="30%"
            center>
                <div style="text-align:center">
                    <div style="text-align:-webkit-center" class="qrcode" ref="qrCodeUrl"></div>
                    <p style="text-align:center;margin-top:10px">{{sellCode}}</p>
                </div>
            </el-dialog>
            <!-- 加入进货单结束 -->

        </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import {cancleOrderItem,removeOrderItem,kuaidi100,showorderDetail,getCompany} from '@/api/xunyou'
export default {
  data() {
    return {
        logistics_name:'zhongtong', // 物流公司
        logistics_code:'zhongtong',
        deliver:[],// 物流信息
        iscancle:false,
        isremove:false,
        codeVisible:false,
        searchValue:'',    
        orderInfoList:JSON.parse(sessionStorage.getItem("orderDetail")) || [],
        orderList:{},
        logistics_number:0,
        sellCode:'', //核销码
        qrcode:'',
        totalMoney:0

    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      },
  mounted(){      
      this.getOrderDetail()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //   查看核销码
    // getSellCode(){

    // },
    // 获取核销码
    creatQrCode(code) {
        this.codeVisible = true
        this.sellCode = code
        setTimeout(()=>{
             this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: code, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },500)
       
    },

      //   跳转到商品详情页面
      jumpGoodsDetail(item){
        //   if(item.type!=2){
              this.$router.push(`/goodsdetail?id=${item.id}`)
        //   }
      },

    //   查询订单详情
    getOrderDetail(){
        showorderDetail({oid:this.orderInfoList.oid}).then(res=>{
            console.log(res)
            if(res.code==0){
                this.orderList = res.rows[0]
                this.totalMoney = (Number(this.orderList.amount)+Number(this.orderList.transportfee)).toFixed(2)
                this.logistics_number = res.rows[0].logistics_company
                this.getCompanyLog()
            }
        })
    },
    getCompanyLog(){
        getCompany({id:this.logistics_number}).then(res=>{
            console.log(res,'dasda')
            if(res){
                this.logistics_code = res.code;
                this.logistics_name = res.name;
            }
            this.getTranspot()
        })
    },
    //   物流查询
    getTranspot(){
         kuaidi100({
            tracking_num: this.orderList.logisticsNumber!=null?this.orderList.logisticsNumber:'78164982674324',
			logistics_name: this.logistics_code // 后续改成变量
         }).then(res => {
                this.deliver = res.data||[]
                this.logisticsNumber = res.nu
                // this.logistics_name = res.com            
                // })
            }) 
    },

      //   订单状态转换
    orderStatus(status){
        switch(status) {
            case 1:
                return '等待买家付款'
                break;
            case 2:
                 return '等待卖家发货'
                break;
            case 3:
                 return '等待买家确认收货'
                break;
            case 4:
                 return '交易成功'
                break;
            case 5:
                 return '交易关闭'
                break;
            case 6:
                 return '等待审核'
                break;
            case 11:
                 return '买家提交退单'
                break;
            case 12:
                 return '退单审核中'
                break;
            case 13:
                 return '等待卖家收货确认'
                break;
            case 14:
                 return '等待卖家退款确认'
                break;
            case 15:
                 return '等待买家收款确认'
                break;
            case 16:
                 return '退款退货完成'
                break;
            case 17:
                 return '已拒绝退款'
                break;
            case 18:
                 return '已取消'
                break;
            default:                
                return '--'
        } 
    },
    // 立即支付
    payOrderNow(amount,transportfee){
        sessionStorage.setItem("account", JSON.stringify(amount || 0)); 
        this.orderList.amount = Number(amount)+Number(transportfee)
        sessionStorage.setItem("orderGoodsInfo", JSON.stringify([this.orderList])); 
        this.$router.push('/orderNow')
    },
      //   取消订单
     cancleOrder(orderId) {
        this.$confirm('确定取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             cancleOrderItem({oid:orderId}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
                this.iscancle = true
                this.orderInfoList.status = 5
                sessionStorage.setItem("orderDetail", JSON.stringify([this.orderInfoList])); 
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('取消失败，请稍后再试！')
            })          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      },
      //   移出订单
    removeOrder(orderId){
        this.$confirm('确定移除订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           removeOrderItem({oid:orderId}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '移除成功!'
                });
                this.isremove = true
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('移除失败，请稍后再试！')
            })   
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已移除'
          });          
        });
    },

    // 重新申请退款
    reApplyMoney(goodsItem){
        const myRefundInfo = {
                oid:this.orderInfoList.oid,
                returnType:this.orderInfoList.status<=2?2:1,//1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
                orderNumber:this.orderInfoList.orderNumber,
                amount:this.orderInfoList.amount,
                goodsItem
            }
            sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
            this.$router.push('/myRefund?status=2')
    },

    // 退款
    reBackMoney(goodsItem,step){ 
    //    console.log(goodsItem,"goodsItem");
        if(step==3){
            sessionStorage.setItem("orderDetail", JSON.stringify(goodsItem));
            this.$router.push('/refundDetail?refund=1')
        }else{
            const myRefundInfo = {
                oid:this.orderInfoList.oid,
                returnType:this.orderInfoList.status<=2?2:1,//1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
                orderNumber:this.orderInfoList.orderNumber,
                amount:this.orderInfoList.amount,
                goodsItem
            }
            console.log(myRefundInfo,'退库随你啦')
            sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
            this.$router.push('/myRefund?status=1')
        }

    }
  },
};
</script>

<style scoped lang="less">
    .rightaside_content{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 5px 0;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        .headerButton {
            display: flex;
            justify-content: space-between;
            button.el-button.el-button--default.el-button--mini {
                // background: #ff6700;
                // color: white;
                background: #f896521a;
                color: #ff6700;
                border: 1px solid #ff6700;
            }
            .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
                background: #ff6700 !important;
                color: white !important;
            }
        }
        .order_goods.el-row {
            border-bottom: 1px solid#DCDFE6;
            padding: 20px;
            box-sizing: border-box;
            .order_Info_item {
                margin-left: 10px;
            }
            .getUser{
                cursor: pointer;
                color: #ff6700;
            }
            .codeStyle{
                font-weight:bold
            }
            .codeUsedStyle{
                font-weight:bold;
                text-decoration: line-through;
            }
        }
        .info_title{
            margin: 0 0 15px;
            font-size: 16px;
            font-weight: 400;
            color: #333;
        }
        .info_content{
                color: #757575;
                p{
                    margin-bottom: 4px;
                }
        }
        .footer_total{
                text-align: right;
                color: #757575;
                p{
                    margin: 10px 0;
                }
                .footer_total_money{
                    color: #ff6700;
                    .finalTotal{
                        font-size: 20px;
                    }
                }
                
        }
       button.el-button.reBackMoney.el-button--default.el-button--mini {
            background: #ff674c;
            color: white;
            border: 1px solid #ff674c;
        }
        button.el-button.reBackMoney.el-button--default.el-button--mini:hover {
            background: #f896521a;
            color:  #ff674c;
            border: 1px solid #ff674c;
        }

    }

// 查看物流
    .getLogistics{
       border-top:0px !important;
       border-bottom:0px !important;
       /deep/.el-collapse-item__header{
           border-bottom:0px !important;
           height:auto;
           line-height: inherit;
           color: coral;
           cursor: pointer;
           display:inline-block;
            margin: 10px 0;
       }
       /deep/.el-collapse-item__wrap{
           border-bottom:0px !important;
       }
       /deep/.el-step__icon{
           height: auto;
       }
       /deep/.el-step__icon-inner[class*=el-icon]:not(.is-status){
               font-size: 10px;
       }
       /deep/.el-step.is-vertical .el-step__title{
            line-height: inherit;
            margin-top: 10px;
            font-weight: bold;
       }
       /deep/.el-step.is-vertical .el-step__icon.is-icon {
            margin-top: 20px;
        }
        /deep/.el-step__title.is-process, /deep/.el-step__description.is-process{
                color: #C0C4CC;
        }
    }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/myOrderDetail.vue